import React from 'react';
import { View, TouchableOpacity, Text, TouchableHighlightBase } from 'react-native';
import { AntDesign, Entypo, FontAwesome, FontAwesome5,   } from '@expo/vector-icons'; 
import OBOrder from './OBOrder';
import Utilities from '../~Utilities/Utilities';
import { AppMain, FontInfo } from '../~Utilities/Constants';
import { OBData, OrdData, MBOData } from '../~Utilities/Data';
import { Connection, ConnectionOrd, ConnectionMkt } from '../~Utilities/Connection';
import { PriceType, TransactionType } from '../~Utilities/Rq';
import TextMBO from '../C_Text/TextMBO';

export interface IOBModify
{
  bindEvent : (onEvent    : (() => void), 
               bSubscribe : boolean) => void;
  oOBData   : OBData | undefined;
}

/*   ====================================================================   */

export default class OBModify extends React.Component<IOBModify>
{
private oOBOrders : OBOrder[] = new Array(0);
private oOBFull   : OBOrder[] = new Array(0);
private oTm       : NodeJS.Timer | undefined;

private oOrdData  : OrdData | undefined = undefined;
private oTextMBO  : TextMBO | null      = null;

constructor(props)
{
  super(props);

  this.Show         = this.Show.bind(this);
  this.ShowAdd      = this.ShowAdd.bind(this);
  this.Hide         = this.Hide.bind(this);
  this.DeSelect     = this.DeSelect.bind(this);
  this.CancelOrders = this.CancelOrders.bind(this);
  this.LinkOrders   = this.LinkOrders.bind(this);
  this.ModifyOrders = this.ModifyOrders.bind(this);
  this.RePopulate   = this.RePopulate.bind(this);
  this.GetMBO       = this.GetMBO.bind(this);
  this.ClearMBO     = this.ClearMBO.bind(this);
}

/*   -------------------------------------------------------------------   */

Show(oOrder    : OBOrder,
     oFullList : OBOrder[])
{
for (let i = 0; i < this.oOBOrders.length; i++)  
  {
  if (this.oOBOrders[i] == oOrder)
    continue;

  this.oOBOrders[i].DisableCancel(true);
  }

this.oOBOrders.splice(0, this.oOBOrders.length);
this.oOBOrders.push(oOrder);  

this.oOBFull = oFullList;

// if (Utilities.FindAny(this.oOBOrders, oOrder) == AppMain.IMAGINARY)
//   {
//   this.oOBOrders.push(oOrder);
//   }

this.setState({visible:true});
this.GetMBO();

/*   -------------------------------------------------------------------   */

if (this.oTm != undefined)
  {
  clearInterval(this.oTm);
  this.oTm = undefined;
  }

//this.oTm = setInterval(()=>{this.GetMBO()}, 2000)
}

/*   -------------------------------------------------------------------   */

ShowAdd(oOrder : OBOrder)
{
// for (let i = 0; i < this.oOBOrders.length; i++)  
//   {
//   if (this.oOBOrders[i] == oOrder)
//     continue;

//   this.oOBOrders[i].DisableCancel();
//   }

// this.oOBOrders.splice(0, this.oOBOrders.length);
// this.oOBOrders.push(oOrder);  

if (Utilities.FindAny(this.oOBOrders, oOrder) == AppMain.IMAGINARY)
  {
  this.oOBOrders.push(oOrder);
  }

this.setState({visible:true});
this.GetMBO();

if (!this.state.visible)
  {
    if (this.oTm != undefined)
    {
    clearInterval(this.oTm);
    this.oTm = undefined;
    }
  
  //this.oTm = setInterval(()=>{this.GetMBO()}, 2000)
  }
}

/*   -------------------------------------------------------------------   */

RePopulate(oOrders : OBOrder[])
{
// let bFound : boolean = false;

this.oOBOrders.splice(0, this.oOBOrders.length);

for (let i = 0; i < oOrders.length; i++)
  {
  //if (oOrders[i].state.bCancel)  
  if (oOrders[i].bIsSelected)  
    {
    this.oOBOrders.push(oOrders[i]);

    // if (!bFound)
    //   {
    //   let oList = oOrders[i].GetOrders();

    //   for (let j = 0; j < oList.length; j++)
    //     {
    //     if (this.oOrdData?.basket_id == oList[i].basket_id)
    //       bFound = true;
    //     }
    //   }
    }
  }

if (this.oOBOrders.length == 0)
  {
  this.setState({visible:false});
  this.ClearMBO();
  }
else
  {
  this.GetMBO();
  }
}

/*   -------------------------------------------------------------------   */

Hide(oOrder? : OBOrder | undefined)
{
if (oOrder == undefined)
  {
  this.oOBOrders.splice(0, this.oOBOrders.length);
  this.setState({visible:false});
  this.ClearMBO();
  return;
  }

/*   -------------------------------------------------------------------   */  

let bFound = Utilities.FindAndDeleteAny(this.oOBOrders, oOrder);

if (this.oOBOrders.length == 0)
  {
  this.setState({visible:false});
  this.ClearMBO();
  }

/*   -------------------------------------------------------------------   */  

if (bFound && this.oOrdData)
  {
  let oList = oOrder.GetOrders();

  for (let i = 0; i < oList.length; i++)
    {
    if (oList[i] == this.oOrdData)
      {
      this.ClearMBO();
      break;  
      }
    }
  }

/*   -------------------------------------------------------------------   */  

if (this.oTm != undefined)
  {
  clearInterval(this.oTm);
  this.oTm = undefined;
  }

/*   -------------------------------------------------------------------   */

return(bFound);
}

/*   -------------------------------------------------------------------   */

GetMBO()
{
if (this.oOBOrders.length == 0)
  return;

/*   -------------------------------------------------------------------   */  

let oOrd: OrdData | undefined;

let oOrders = this.oOBOrders[0].GetOrders();

/*   -------------------------------------------------------------------   */

for (let i = 0; i < oOrders.length; i++)
  {
  if (oOrders[i].route == 'simulator')
    continue;

  if (oOrders[i].price_type_api == PriceType.LIMIT)
    {
    if (oOrd == undefined)
      {
      oOrd = oOrders[i];
      }
    else
      {
      let iTime = oOrders[i].time;

      if (oOrd?.time && iTime) //&& oOrd?.route != 'simulator')
        {
        if (oOrd.time > iTime)
          {
          oOrd = oOrders[i];
          }
        }
      }
    }
  }

/*   -------------------------------------------------------------------   */

if (!oOrd || oOrd.limit_price == undefined)
  {
  this.ClearMBO();
  return;  
  }

/*   -------------------------------------------------------------------   */

// let oMBOData : MBOData | undefined;

// if (this.props.oOBData)
//   oMBOData = ConnectionMkt.GetMBOData(this.props.oOBData);


// if (oMBOData && this.oOrdData?.limit_price == oOrd.limit_price)
//   {
//   return;
//   }
// else
//   {
  // if (this.oOrdData && this.oOrdData.limit_price != undefined)
  //   {
  //   if (this.props.oOBData)
  //     {
  //     let oMBOOldData = ConnectionMkt.GetMBOData(this.props.oOBData);

  //     if (oMBOOldData)
  //       {
  //       oMBOOldData.dPrice
  //       }
  //     }
      
  //   }  
  // }  


/*   -------------------------------------------------------------------   */  

let oMBOData : MBOData | undefined;

if (this.props.oOBData)
  oMBOData = ConnectionMkt.GetMBOData(this.props.oOBData);

if (oMBOData) //MBO price exits
  {
  if (oMBOData.dPrice != oOrd.limit_price)
    {
    this.ClearMBO();
    }
  else
    {
    if (oMBOData.sExchOrdId != oOrd.exch_order_id)
      {
      this.oOrdData       = oOrd;
      oMBOData.sExchOrdId = oOrd.exch_order_id;
      oMBOData.bBuy       = oOrd.txn_type_api == TransactionType.BUY;

      ConnectionMkt.RecalculateMBO(oMBOData, oOrd.exch_order_id);
      }

    return;
    }
  }

/*   -------------------------------------------------------------------   */  

this.oOrdData       = oOrd; 

oMBOData            = new MBOData();
oMBOData.dPrice     = oOrd.limit_price;
oMBOData.sExchOrdId = oOrd.exch_order_id;
oMBOData.bBuy       = oOrd.txn_type_api == TransactionType.BUY;

this.props.oOBData?.oMBOData?.push(oMBOData);
this.oTextMBO?.SetMBO(oMBOData);

ConnectionMkt.oConn?.Rq_GetMBO(oOrd);
}

/*   ------------------------------------------------------------------   */

DeSelect()
{
for (let i = 0; i < this.oOBOrders.length; i++)
  this.oOBOrders[i].DisableCancel();
}

/*   -------------------------------------------------------------------   */

ClearMBO()
{
if (this.oOrdData)
  {
  this.oTextMBO?.SetMBO(undefined);

  let oMBOData = this.props.oOBData?.oMBOData?.length? this.props.oOBData.oMBOData[0] : undefined; // ConnectionMkt.GetMBOData(this.props.oOBData);

  if (this.oOrdData && oMBOData)
    ConnectionMkt.oConn?.Rq_UnSubscribeMBO(this.oOrdData, oMBOData);

  this.props.oOBData?.oMBOData?.pop();

  this.oOrdData = undefined;
  }
}

/*   -------------------------------------------------------------------   */

CancelOrders()
{
for (let i = 0; i < this.oOBOrders.length; i++)
  this.oOBOrders[i].CancelOrders();
}

/*   -------------------------------------------------------------------   */

LinkOrders()
{
let oInitOrder : OrdData | undefined = undefined;
let oOrder     : OrdData | undefined;
let oOrdList   : OrdData[]           = new Array(0);

/*   -------------------------------------------------------------------   */

if (this.oOBOrders.length == 0)
  return;

/*   -------------------------------------------------------------------   */

if (this.oOBOrders.length > 1)
  {
  for (let i = 0; i < this.oOBOrders.length; i++)
    {
    if (oInitOrder == undefined)
      {
      oOrder = this.oOBOrders[i].GetAValidOrder();

      if (oOrder == undefined)
        continue;
    
      oInitOrder = oOrder;
      oOrdList.push(oOrder);
      }
    else
      {
      oOrder = this.oOBOrders[i].GetAValidOrder(oInitOrder.qty);

      if (oOrder == undefined)
        continue;
  
      if (oInitOrder.basket_id != oOrder.basket_id)
        oOrdList.push(oOrder);
      }
    }
  }
else
  {
  oInitOrder = this.oOBOrders[0].GetAValidOrder();

  if (oInitOrder == undefined)
    return;

  oOrdList.push(oInitOrder);

  for (let i = 0; i < this.oOBFull.length; i++)
    {
    oOrder = this.oOBFull[i]?.GetAValidOrder(oInitOrder.qty);

    if (oOrder != undefined && oOrder.basket_id != oInitOrder.basket_id)
      {
      oOrdList.push(oOrder);
      }
    }
  }

/*   -------------------------------------------------------------------   */

if (oOrdList.length > 1)
  {
  ConnectionOrd.oConn?.Rq_LinkOrders(oInitOrder?.acc_key, oOrdList);  
  }
}

/*   -------------------------------------------------------------------   */

ModifyOrders(iLevel : number)
{
for (let i = 0; i < this.oOBOrders.length; i++)
  {
  this.oOBOrders[i].ModifyOrders(iLevel);
  }
}

/*   -------------------------------------------------------------------   */

componentDidMount() 
{
}

/*   -------------------------------------------------------------------   */

componentWillUnmount() 
{
if (this.oTm != undefined)
  {
  clearInterval(this.oTm);
  this.oTm = undefined;
  }
}

/*   -------------------------------------------------------------------   */

state = {
    visible: false
}

/*   -------------------------------------------------------------------   */

render() 
{
if (this.state.visible == false)
  {
  //if (this.oOBFull?.length)
    // return(
    //   <View style={{position:'absolute', right:22, bottom:80, flexDirection:'column', zIndex:2}}>
    //   <TouchableOpacity onPress={()=>{ this.LinkOrders() }} 
    //    style={{justifyContent:'center', borderRadius:10, width:20, height:20, borderWidth:1, borderColor:'rgba(112,128,144,.2)', alignItems:'center', alignContent:'center'}} >
    //   <Text style={[FontInfo.appStyles.txt_normal, {marginTop:2, alignSelf:'center', fontSize:FontInfo.iFontSize-2, color:'slategrey'}]}>i</Text>
    //   </TouchableOpacity>
    //   </View>
    // );
  // else
       return(null);
  }
else
  return(
    // <Pressable style={{position:'absolute', width:'100%', height:'100%', zIndex:200, backgroundColor:'rgba(0,0,0,0)'}}
    //   onPress={ ()=>{ this.Hide() } }
    //   >
      <View style={{position:'absolute', right:17, top:40, flexDirection:'column', zIndex:2, alignItems:'flex-end'}}>
      <TouchableOpacity onPress={()=>{ this.LinkOrders() }} 
      style={{alignItems:'center', justifyContent:'center', backgroundColor:'orange', borderRadius:25, width:45, height:45, margin:5, marginTop:0, marginBottom:4}}>
      <Entypo name="link" size={24} color="white" />
      </TouchableOpacity>

      <TouchableOpacity onPress={()=>{ this.CancelOrders() }} 
      style={{alignItems:'center', justifyContent:'center', backgroundColor:'#ea3c53', borderRadius:25, width:45, height:45, margin:5, marginVertical:4}}>
      <FontAwesome name="close" size={24} color="white" />
      </TouchableOpacity>

      <TouchableOpacity onPress={()=>{ this.ModifyOrders(1) }} 
      style={{alignItems:'center', justifyContent:'center', backgroundColor:'deepskyblue', borderRadius:25, width:45, height:45, margin:5, marginVertical:4}}>
      <AntDesign name="arrowup" size={24} color="white" />
      </TouchableOpacity>
      
      <TouchableOpacity onPress={()=>{ this.ModifyOrders(-1) }} 
      style={{alignItems:'center', justifyContent:'center', backgroundColor:'deepskyblue', borderRadius:25, width:45, height:45, margin:5, marginVertical:4}}>
      <AntDesign name="arrowdown" size={24} color="white" />
      </TouchableOpacity>

      <TextMBO  ref={node=>{this.oTextMBO = node}} oMBOData={this.props.oOBData?.oMBOData?.length? this.props.oOBData?.oMBOData[0] : undefined} bindEvent={this.props.bindEvent}/>

      </View>
      // </Pressable>
    );
}
}